/**
 * Wrapper for navigator.onLine
 * @returns TRUE if browser network is online, returns FALSE otherwise
 */ export function getIsOnline() {
    return navigator.onLine;
}
